import { ServiceGroup } from "./models/service/servicegroup.model";
import { Injectable } from "@angular/core";

@Injectable()
export class ServiceGroupService{
  constructor(){
    
  }
  getListServiceGroup():ServiceGroup[]{
    let typeList:ServiceGroup[]=[];
    typeList.push( new ServiceGroup("Mã thẻ ", 1,  false));
    typeList.push( new ServiceGroup("Trả trước", 2,  false ));
    typeList.push( new ServiceGroup( "Trả sau", 4, false ));
    typeList.push( new ServiceGroup("Hóa đơn", 8, false));
    //typeList.push( new ServiceGroup("Airline", 16, false ));
    return typeList;
  }
}
